import React from "react";
import { FileText } from "lucide-react";

export default function InspectorOverview({ steps = [] }) {
  const overviewSteps = steps.filter((step) => !["intro", "chiusura"].includes(step.id));

  return (
    <div className="space-y-4">
      <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <h1 className="text-2xl font-bold text-slate-950">Area ispettore</h1>
        <p className="mt-2 text-slate-600">
          Tutta la documentazione aziendale utile durante il controllo, raccolta in un'unica pagina e pronta da aprire.
        </p>
      </div>

      <div className="grid gap-4 lg:grid-cols-2">
        {overviewSteps.map((step) => {
          const links = Array.isArray(step.moduleLinks)
            ? step.moduleLinks
            : step.modulePath
              ? [{ path: step.modulePath, label: step.moduleLabel || "Apri modulo" }]
              : [];

          return (
            <section key={step.id} className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
              <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">{step.title}</div>
              {step.objective && (
                <div className="mt-2 text-sm font-semibold text-slate-900">{step.objective}</div>
              )}
              <p className="mt-2 text-sm text-slate-600">{step.instruction}</p>

              {links.length > 0 && (
                <div className="mt-4 flex flex-wrap gap-2">
                  {links.map((link) => (
                    <a
                      key={`${step.id}-${link.path}`}
                      href={link.path}
                      className="inline-flex items-center gap-2 rounded-xl border px-4 py-2 text-sm font-bold hover:bg-slate-50"
                    >
                      <FileText size={16} />
                      {link.label}
                    </a>
                  ))}
                </div>
              )}

              {Array.isArray(step.checklist) && step.checklist.length > 0 && (
                <div className="mt-4 space-y-2">
                  {step.checklist.map((item) => (
                    <div key={item} className="rounded-xl bg-slate-50 px-3 py-2 text-sm text-slate-700">
                      {item}
                    </div>
                  ))}
                </div>
              )}
            </section>
          );
        })}
      </div>
    </div>
  );
}
